<template>
  <view>
    <TsButton
      wx:for="{{helpList}}"
      wx:key="type"
      class="help-item"
      wx:class="{{ {online:item.type === 'onlineHelp'} }}"
      bind:click="handleHelpClick(item)"
    >
      <image mode="widthFix" class="help-item-icon" src="{{item.icon}}" />
      <view class="help-item-title">
        <view>{{item.title}}</view>
        <view class="help-item-subtitle" wx:show="{{item.subTitle}}">{{item.subTitle}}</view>
      </view>
      <view class="help-item-content">
        <view class="help-item-content-btn" wx:if="{{item.type === 'onlineHelp'}}">客服</view>
        <view wx:else>{{item.content}}</view>
      </view>
    </TsButton>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import {
    buildUrl,
    is,
    makePhoneCall,
    setClipboardData,
    showToast,
    goto,
    login,
    locate
  } from '@didi/spring-base'

  createComponent({
    props: {
      email: {
        type: String,
        value: ''
      },
      phone: {
        type: String,
        value: ''
      },
      onlineSource: {
        type: String,
        value: ''
      },
      onlineOrderId: {
        type: String,
        value: ''
      },
      bizType: {
        type: String,
        value: ''
      }
    },
    computed: {
      onlineParams() {
        const BIZ_PARAMS = {
          train: {
            businessType: '291',
            subBusinessType: '37325',
          },
          flights: {
            businessType: '451',
            subBusinessType: '37507',
          }
        }
        const bizParams = BIZ_PARAMS?.[this.bizType] || {}
        return {
          ...bizParams,
          source: this.onlineSource,
          orderId: this.onlineOrderId,
        }
      },
      helpList() {
        return [
          (this.onlineSource && this.bizType) ? {
            type: 'onlineHelp',
            icon: 'https://ut-static.udache.com/webx/sfc/FdTS1OsFiBMSHnLKVoyeo_image.png',
            title: '在线客服',
            subTitle: '专人客服，处理更快',
            content: buildUrl('https://help.xiaojukeji.com/static/im/?tenantId=didi&roleType=1', this.onlineParams)
          } : null,
          this.phone ? {
            type: 'phone',
            icon: 'https://ut-static.udache.com/webx/sfc/KPb3bTrJayRECcliadqiv.png',
            title: '官方电话',
            content: this.phone
          } : null,
          this.email ? {
            type: 'email',
            icon: 'https://ut-static.udache.com/webx/sfc/EHdqaE1YVCDwErFFyJPE2.png',
            title: '投诉邮箱',
            content: this.email
          } : null,
        ].filter(Boolean)
      }
    },
    methods: {
      async handleHelpClick(item) {
        if (item.type === 'phone') {
          makePhoneCall({
            phoneNumber: item.content
          })
        }else if(item.type === 'email') {
          await setClipboardData(item.content)
          showToast({
            title: '复制成功',
            icon: 'success',
          })
        }else if(item.type === 'onlineHelp') {
          login().then(async (userInfo) => {
            const locationInfo = await locate()
            goto({
              url: item.content,
              params: {
                cityId: locationInfo.cityId,
                token: userInfo.token,
              }
            })
          }).catch((err) => {
            console.log('未登录', err)
          })
        }
      }
    }
  })
</script>

<style lang="stylus" scoped>
.help-item
  margin 0 16px 10px
  padding 12px 16px
  display flex
  align-items center
  border-radius 10px
  background linear-gradient(270deg, #F2F6F9 12%, rgba(242, 246, 249, 0.3) 100%)
  overflow hidden
  &:first-child
    margin-top 6px
  &:last-child
    margin-bottom 58px
  &-icon
    width 32px
    height 32px
    flex none
    margin-right 12px
  &-title
    line-height 1
    display flex
    flex 1
    flex-direction column
    justify-content center
    align-items flex-start
    white-space nowrap
    font-family PingFangSC-Medium
    font-weight 500
    color #222
    font-size 16px
  &-subtitle
    font-family PingFangSC-Regular, PingFangSC, Helvetica, Arial, sans-serif
    font-weight 400
    color #666
    font-size 12px
    margin-top 7px
  &-content
    flex none
    line-height 1
    color #666
    font-size 14px
    &-btn
      position relative
      display flex
      align-items center
      justify-content center
      color #fff
      width 75px
      height 32px
      font-family PingFangSC-Medium
      font-weight 500
      font-size 14px
      border-radius 7px
      background #338FFF
      &::after
        font-family PingFangSC-Medium
        padding 3px 7px
        font-weight 500
        font-size 9px
        position absolute
        content '推荐'
        background linear-gradient(180deg, #FF8C00 6%, #FF6A00 100%)
        border 0.5px solid #FFFFFF
        border-radius 8px 8px 8px 0
        right 0
        bottom 27px
  &.online
    padding 20px 16px
    .help-item-icon
      width 44px
      height 44px
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'TsButton': '@didi/spring-ui/ts-button',
    }
  }
</script>